import api from "./api";

const findFinancialData = () => api.get(`api/dadosFinanceiro`);

// Backoffice: cobranças (billings) de um usuário específico.
const findUserBillings = (userId) =>
  api.get(`api/dadosFinanceiro/usuario/${userId}`);

export { findFinancialData, findUserBillings };
